import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { style } from '../../utils/style.js';
const activeDotStyles = {
    'horizontal-list': 'w-6',
    'vertical-list': 'h-6',
};
const dotStyle = 'cursor-pointer rounded-full transition-width duration-300 bg-primary-main group-data-secondary:bg-white';
const inactiveDotStyle = 'w-2 h-2 opacity-30';
export const renderDotButton = ({ activeIndex, onClick, listType = 'horizontal-list' }) => (_, idx) => (_jsx("div", { className: style(dotStyle, idx === activeIndex ? activeDotStyles[listType] : inactiveDotStyle), role: "button", "aria-hidden": true, onClick: () => onClick(idx) }, String(idx)));
//# sourceMappingURL=renderDotButton.js.map